<template>
  <section class="no-connection" :style="{ backgroundImage: `url('${backgroundImage}')` }">
    <div class="no-connection__content">
      <img class="no-connection__logo" :src="logo" alt="EduMark" />
      <span class="no-connection__title">{{ t('no_connection_label') }}</span>
      <span class="no-connection__text">{{ t('no_connection_body') }}</span>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

import logo from '@/assets/login/logo.svg';
import backgroundImage from '@/assets/login/background-login-page.png';

const { t } = useI18n();
</script>

<style scoped>
.no-connection {
  position: fixed;
  inset: 0;
  z-index: 10001;
  min-height: 100vh;
  background-color: #fff;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
}

.no-connection__content {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 150px;
  padding: 0 24px;
  color: #fff;
  text-align: center;
  font-family: Roboto, sans-serif;
}

.no-connection__logo {
  width: 150px;
  max-width: 70vw;
}

.no-connection__title {
  margin-top: 24px;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.3;
}

.no-connection__text {
  max-width: 360px;
  margin-top: 8px;
  font-size: 15px;
  line-height: 1.4;
}
</style>
